import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';

/** Brand name, truncated to 1 line. Renders a space when empty to preserve layout height. */
export function CardBrand(): JSX.Element {
  const { brandName } = useCardContext();

  return <Brand data-testid='card-brand'>{brandName || ' '}</Brand>;
}

const Brand = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  color: #646d72;
  display: -webkit-box;
  font: 12px/1 ${({ theme }) => theme.customized.fonts.secondary};
  margin-top: 4px;
  overflow: hidden;
`;
